import axios from 'axios'
import {
    authSessionContext, isAuthSessionCurrent, hasAuthSessionChanged,
    redirectChangedSession, sessionChangedError,
} from '@/auth/session'

// Create instance called instance
const http = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
});

const isPublicSharedDocumentRoute = () => (
    typeof window !== 'undefined'
    && window.location
    && window.location.pathname.startsWith('/documents/shared')
);
let refreshRequest = null;
// var token = localStorage.getItem('token');

// http.defaults.headers.common['Authorization'] = 'Bearer ' + token;

// // declare a response interceptor
// http.interceptors.response.use((response) => {
//     return response;
// }, error => {
//     // handle the response error

//     if (error.response.status == 401) {
//         window.location.href = '/login';
//     } else {
//         return Promise.reject(error);
//     }
// });
    const authService = {
        refreshToken: async () => {
            if (refreshRequest) return refreshRequest;

            refreshRequest = (async () => {
            const context = authSessionContext();
            try {
                if (!isAuthSessionCurrent()) return false;
                const refreshToken = localStorage.getItem("refreshToken");
                const response = (await axios.get(`${process.env.VUE_APP_BASE_URL.replace(/\/$/, '')}/auth/refresh`, { headers: { Authorization: `Bearer ${refreshToken}` } })).data
                const { accessToken, refreshToken: nextRefreshToken } = response.data;

                // Logout, another login, or role selection may finish while this waits.
                if (!isAuthSessionCurrent() || authSessionContext() !== context) return false;
                if (localStorage.getItem('refreshToken') !== refreshToken) return true;
                if (!accessToken || !nextRefreshToken) return false;

                // Update the access token and refresh token in localStorage
                localStorage.setItem('accessToken', accessToken);
                localStorage.setItem('refreshToken', nextRefreshToken);

                // Retry the original API request with the new access token
                return true;
            } catch (error) {
                if (!isAuthSessionCurrent() || authSessionContext() !== context) return false;
                if (isPublicSharedDocumentRoute()) {
                    return false
                }
                window.location.href = '/login';
                // Handle token refresh error (e.g., logout the user)
                return false;
            } finally {
                refreshRequest = null;
            }
            })();

            return refreshRequest;
        }
    }
    http.interceptors.request.use(
        config => {
            const publicAuth = /^\/?auth\/(login|signup|verify-email|resend-email-verification|reset-password|signup-via-invite|admin\/(login|verify-otp|resend-mfa-token))/.test(config.url || '');
            if (hasAuthSessionChanged() && !publicAuth && !isPublicSharedDocumentRoute()) {
                redirectChangedSession();
                return Promise.reject(sessionChangedError());
            }
            config.authSessionContext = publicAuth ? '' : authSessionContext();
            const accessToken = isAuthSessionCurrent() && !publicAuth ? localStorage.getItem("accessToken") : null;
            if (accessToken) {
                config.headers.Authorization = `Bearer ${accessToken}`;
            }
            return config;
        },
        error => Promise.reject(error)
    );

    http.interceptors.response.use(
        response => {
            if (response.config?.authSessionContext && response.config.authSessionContext !== authSessionContext()) {
                redirectChangedSession();
                return Promise.reject(sessionChangedError());
            }
            return response;
        },
        async error => {
            const originalRequest = error.config || {};
            const status = error.response?.status;
            if (originalRequest.authSessionContext && originalRequest.authSessionContext !== authSessionContext()) {
                redirectChangedSession();
                return Promise.reject(sessionChangedError());
            }
                // if(error.response.status===403){
                //     window.location.href = '/error-404';
                //     //page not found
                //     return false;
                // }
            // Handle token expiration and retry the request with a refreshed token
            console.log("error.response.status: ", status)
                if (status === 401 && originalRequest.authSessionContext && !originalRequest.retriedAfterRefresh) {
                    console.log("vào refreshToken")
                    originalRequest.retriedAfterRefresh = true;
                    const isRefreshSuccessful = await authService.refreshToken();
                    if (isRefreshSuccessful) {
                        return http(originalRequest);
                    }
                } else if (status === 401 && !!originalRequest.retriedAfterRefresh) {
                    if (isPublicSharedDocumentRoute()) {
                        return Promise.reject(error.response.data)
                    }
                    window.location.href = '/login';
                }
            // Network, CORS, and timeout errors do not have an HTTP response.
            // Preserve the original Axios error so callers see the real cause.
            return Promise.reject(error.response?.data || error);
        }
    );

export default http;
